<template>
  <div class="pie">
    <div ref="echarts" id="echarts" style="width:100%;height:100%;"></div>
  </div>
</template>
<script>
export default {
  props: {
    pieData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      echartsData: this.pieData
    }
  },
  watch: {
    pieData (newV) {
      this.init_pie(this.$refs.echarts, newV)
    }
  },
  mounted () {
    this.init_pie(this.$refs.echarts, this.echartsData)
  },
  methods: {
    init_pie (name, data) {
      let myChart = this.$echarts.init(name)
      let option = {
        tooltip: {
          trigger: 'item'
        },
        series: [
          {
            name: '贸易对接',
            type: 'pie',
            radius: ['50%', '80%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '40',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: data
          }
        ]
      }
      myChart.setOption(option)
      window.addEventListener('resize', () => {
        myChart.resize()
      })
    }
  }
}
</script>
<style lang="less" scoped>
.pie {
  width: 100%;
  height: 100%;
  color: #c55e59;
}
</style>



// WEBPACK FOOTER //
// src/components/pie.vue